define([], () => {
    'use strict';

    // This noop script can be used for preventing rogue RequireJS loads from returning 404.
    // That situation might occur for example if a third party library such as Yotpo
    // finds our RequireJS in the DOM and uses it to try to require a library.
    return function () {};
});
